import { Flex, Div } from '@fastnorth/kraken/components/layout';
import { ThumbnailImage } from '@fastnorth/kraken/components/image';
import { Text } from '@fastnorth/kraken/components/typography';
import { useTranslation } from 'react-i18next';
import type { ResultEvent } from '../../types/events';

type TimerDetailsProps = {
  timingProvider: ResultEvent['provider'];
  inlineLogo?: boolean;
};

const TimerDetails = ({
  timingProvider,
  inlineLogo = true,
}: TimerDetailsProps): React.JSX.Element => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa' });
  const { logo, label } = timingProvider || {};

  const logoPositionClass = inlineLogo ? 'flex-row items-center' : 'flex-col items-start';

  return (
    <Flex className={`${logoPositionClass}`} gap={'7'} data-testid={'timer-details'}>
      {logo && (
        <ThumbnailImage
          size={inlineLogo ? 'sm' : 'md'}
          src={logo}
          alt={t('layout.header.timer_logo_text')}
        />
      )}
      {label && (
        <Text>
          {t('layout.header.timing_by_with_label', {
            label: (
              <Div key={'timer-details-label'} className={'block font-semibold'}>
                {label}
              </Div>
            ),
          })}
        </Text>
      )}
    </Flex>
  );
};

export default TimerDetails;
